import React from 'react';
export function ScandiLogos() {
  return <div className="min-h-screen bg-[#fafaf8] py-16 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-739">
      <div className="max-w-7xl mx-auto" data-id="element-740">
        <div className="text-center mb-16" data-id="element-741">
          <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight mb-4" data-id="element-742">
            Scandinavian Wordmarks
          </h1>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto" data-id="element-743">
            Subtle, restrained typography with quiet Nordic influence — clean
            lines, generous space, and purposeful simplicity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-744">
          {/* 1. Clean Wide */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-745">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-746">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-747">
                1. Clean Wide
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-748">
                Light / Wide tracking / Navy
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-749">
              <div className="flex items-center" data-id="element-750">
                <span className="text-xl font-light text-[#0f2546] tracking-[0.25em] uppercase" data-id="element-751">
                  Swedenmark
                </span>
                <span className="text-xl font-medium text-[#005293] tracking-[0.25em] uppercase ml-3" data-id="element-752">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 2. Warm Gray */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-753">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-754">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-755">
                2. Warm Gray
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-756">
                Lowercase / Warm / Gold dot
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-[#fafaf8]" data-id="element-757">
              <div className="flex items-baseline" data-id="element-758">
                <span className="text-2xl font-normal text-[#4a4a4a] tracking-tight" data-id="element-759">
                  swedenmark ai
                </span>
                <div className="w-1.5 h-1.5 rounded-full bg-[#c8a84e] ml-1.5" data-id="element-760"></div>
              </div>
            </div>
          </div>

          {/* 3. Swedish Blue */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-761">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-762">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-763">
                3. Swedish Blue
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-764">
                Bold / Blue accent / Clean
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-765">
              <div className="flex items-baseline" data-id="element-766">
                <span className="text-2xl font-semibold text-[#0f2546] tracking-tight" data-id="element-767">
                  Swedenmark
                </span>
                <span className="text-2xl font-semibold text-[#005293] ml-2" data-id="element-768">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 4. Thin Bar */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-769">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-770">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-771">
                4. Thin Bar
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-772">
                Light / Bar separator / Airy
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-773">
              <div className="flex items-center" data-id="element-774">
                <span className="text-xl font-light text-[#3a3a3a] tracking-wide lowercase" data-id="element-775">
                  swedenmark
                </span>
                <span className="text-xl font-extralight text-slate-300 mx-3" data-id="element-776">
                  |
                </span>
                <span className="text-xl font-light text-[#3a3a3a] tracking-wide lowercase" data-id="element-777">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* 5. Stacked Minimal */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-778">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-779">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-780">
                5. Stacked Minimal
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-781">
                Stacked / Centered / Quiet
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-782">
              <div className="flex flex-col items-center leading-tight" data-id="element-783">
                <span className="text-xs font-medium text-slate-400 tracking-[0.4em] uppercase" data-id="element-784">
                  Swedenmark
                </span>
                <span className="text-3xl font-bold text-[#0f2546] tracking-tight mt-1" data-id="element-785">
                  AI
                </span>
              </div>
            </div>
          </div>

          {/* 6. Gold Accent */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-786">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-787">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-788">
                6. Gold Accent
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-789">
                Domain / Gold dot / Understated
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-790">
              <div className="flex items-baseline" data-id="element-791">
                <span className="text-2xl font-medium text-[#0f2546] tracking-tight lowercase" data-id="element-792">
                  swedenmark
                </span>
                <span className="text-2xl font-medium text-[#c8a84e] lowercase" data-id="element-793">
                  .ai
                </span>
              </div>
            </div>
          </div>

          {/* 7. Diacritical Nod */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-794">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-795">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-796">
                7. Diacritical Nod
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-797">
                Swedish ä / Subtle cultural nod
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-798">
              <div className="flex items-baseline" data-id="element-799">
                <span className="text-2xl font-bold text-slate-800 tracking-tight lowercase" data-id="element-800">
                  swedenmärk
                </span>
                <span className="text-2xl font-light text-slate-400 ml-1 lowercase" data-id="element-801">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* 8. Geometric Even */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-802">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-803">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-804">
                8. Geometric Even
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-805">
                Uppercase / Even spacing / Balanced
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-806">
              <span className="text-lg font-medium text-[#0f2546] tracking-[0.15em] uppercase" data-id="element-807">
                SWEDENMARK AI
              </span>
            </div>
          </div>

          {/* 9. Two-Weight */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-808">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-809">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-810">
                9. Two-Weight
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-811">
                Light + Bold / Contrast within
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-812">
              <div className="flex items-baseline" data-id="element-813">
                <span className="text-2xl font-light text-[#0f2546] tracking-tight lowercase" data-id="element-814">
                  sweden
                </span>
                <span className="text-2xl font-bold text-[#0f2546] tracking-tight lowercase" data-id="element-815">
                  mark
                </span>
                <span className="text-2xl font-light text-[#0f2546] tracking-tight lowercase ml-1" data-id="element-816">
                  ai
                </span>
              </div>
            </div>
          </div>

          {/* 10. Underscore */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-817">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-818">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-819">
                10. Underscore
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-820">
                Tech / Functional / Nordic restraint
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-821">
              <span className="text-xl font-medium text-[#2a2a2a] tracking-tight lowercase font-mono" data-id="element-822">
                swedenmark_ai
              </span>
            </div>
          </div>

          {/* 11. Spaced Caps */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-823">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-824">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-825">
                11. Spaced Caps
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-826">
                Ultra-wide / Whisper weight
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-white" data-id="element-827">
              <span className="text-sm font-light text-slate-600 tracking-[0.5em] uppercase" data-id="element-828">
                SWEDENMARK AI
              </span>
            </div>
          </div>

          {/* 12. Warm Minimal */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col" data-id="element-829">
            <div className="p-3 border-b border-slate-100 bg-slate-50/50" data-id="element-830">
              <h3 className="text-sm font-semibold text-slate-800" data-id="element-831">
                12. Warm Minimal
              </h3>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-0.5" data-id="element-832">
                Medium / Warm tone / Approachable
              </p>
            </div>
            <div className="p-12 flex-1 flex items-center justify-center bg-[#faf9f6]" data-id="element-833">
              <div className="flex items-baseline" data-id="element-834">
                <span className="text-2xl font-medium text-[#3d3529] tracking-tight" data-id="element-835">
                  Swedenmark
                </span>
                <span className="text-2xl font-medium text-[#7a6f5d] ml-2" data-id="element-836">
                  AI
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}